module.exports = __webpack_public_path__ + "static/img/curstage_3.4f05251c.png";